import InputWrapper from '../wrapper/InputWrapper';
import CurrencyInput, {
  CurrencyInputProps,
} from 'react-currency-input-field';
import {INumberInputProps } from 'types/components/inputs/input.interface';

const NumberInput = ({ ...inputProps }: INumberInputProps) => {
  return (
    <InputWrapper
      {...inputProps}
      name={inputProps.name ?? ''}
      render={inputProps => (
        <CurrencyInput className='currency-input' {...(inputProps as CurrencyInputProps)} />
      )}
    />
  );
};

export default NumberInput;
